export const status = {
  pending: '待審核',
  lackOfDocument: '待補件',
  rejected: '審核不通過',
  accepted: '審核通過',
  delivered: '已出貨',
  canceled: '已取消',
};
